<template>
  <main :class="$style.container">
    <router-link :to="{ name: 'login' }">
      <base-icon
        name="logo"
        :class="$style.logo"
        themeColor="light"
        size="50px"
        alt="bloq-logo"
      />
    </router-link>

    <h1 :class="$style.title" v-show="!hasPendingTasks">{{ title }}</h1>
    <router-view v-show="!hasPendingTasks" />

    <infinite-loader />
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import InfiniteLoader from '@/components/InfiniteLoader'
import auth from '@/services/auth'

export default {
  name: 'public-main',

  components: { InfiniteLoader },

  created() {
    auth.logout()
  },

  computed: {
    ...mapGetters(['hasPendingTasks']),
    ...mapState(['title'])
  }
}
</script>

<style lang="scss" module>
.container {
  background-color: $color-primary-dark;
  min-height: 100vh;
  padding: 12vh spacing(1) spacing(2);

  @include wider-than(390px) {
    padding: 12vh spacing(2) spacing(2);
  }
}

.container .logo {
  width: 100px;
  display: block;
  margin: 0 auto;
}

.title {
  margin-top: spacing(4);
  margin-bottom: spacing(4);
  color: $color-light;
  font-size: $size-x-large;
  font-weight: $weight-regular;
  letter-spacing: -0.1px;
  text-align: center;

  @include wider-than(700px) {
    font-size: $size-xx-large;
  }
}
</style>
